import { get } from '../fable'

const getQuote = async (id: string) => await get(`/quotes/${id}`)

export const quote = {
  getQuote,
}
